import { CloseIcon } from "@chakra-ui/icons";
import { Flex, Text, Button } from "@chakra-ui/react";
import { t } from "i18next";
import { FunnelComponentProps } from "../../funnel/types";

export function PdfModalHeader({ onClose }: FunnelComponentProps) {
  return (
    <Flex flexDirection="row" justifyContent="space-between" width="100%" padding="16px 24px">
      <Text variant="title" fontSize="20px" color="dune.dune" fontWeight="600">
        {t("components.payments.pdf.digitalDownload")}
      </Text>
      <Button
        alignSelf="center"
        variant="iconOnly"
        onClick={onClose}
        minWidth={0}
      >
        <CloseIcon alignSelf="center" color="dune.100" />
      </Button>
    </Flex>
  );
}
